import { useState, useEffect } from "react";

export default function InstallPWA() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowBanner(true);
    };

    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") {
      setShowBanner(false);
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: "24px",
        left: "50%",
        transform: "translateX(-50%)",
        background: "#ffffff",
        border: "1px solid #EDEDED",
        borderRadius: "12px",
        padding: "16px 20px",
        display: "flex",
        alignItems: "center",
        gap: "16px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        zIndex: 9999,
        maxWidth: "420px",
        width: "90%",
      }}
    >
      <img
        src="/logo192.png"
        alt="Pretzu"
        style={{ width: 40, height: 40, borderRadius: 8 }}
      />
      <div style={{ flex: 1 }}>
        <p
          style={{ margin: 0, fontWeight: 600, color: "#595759", fontSize: 14 }}
        >
          Instala Pretzu
        </p>
        <p style={{ margin: 0, color: "#909090", fontSize: 12 }}>
          Acceso rápido desde tu pantalla de inicio
        </p>
      </div>
      <div style={{ display: "flex", gap: 8 }}>
        <button
          onClick={handleDismiss}
          style={{
            background: "none",
            border: "1px solid #EDEDED",
            borderRadius: 8,
            padding: "6px 12px",
            color: "#909090",
            cursor: "pointer",
            fontSize: 13,
          }}
        >
          Ahora no
        </button>
        <button
          onClick={handleInstall}
          style={{
            background: "#8E24AA",
            border: "none",
            borderRadius: 8,
            padding: "6px 12px",
            color: "#ffffff",
            cursor: "pointer",
            fontSize: 13,
            fontWeight: 600,
          }}
        >
          Instalar
        </button>
      </div>
    </div>
  );
}
